module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-13.6a9a3b61.png";